<script setup lang="ts">
export interface CiCampsiteMediaPanonoProps {
  panonoId: string;
  selected?: boolean;
}
const props = withDefaults(defineProps<CiCampsiteMediaPanonoProps>(), {
  selected: false,
});
</script>

<template>
  <div class="h-full">
    <div
      class="aspect-video rounded"
      style="-webkit-mask-image: -webkit-radial-gradient(white, black)"
    >
      <div
        v-if="!props.selected"
        class="click-area absolute left-0 top-0 z-10 size-full cursor-pointer"
      />
      <client-only>
        <iframe
          :src="`//cloud.panono.com/p/${props.panonoId}/embed`"
          class="absoluter left-0 top-0 size-full"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="panono"
          loading="lazy"
        />
      </client-only>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.no-touch .click-area {
  @apply block;
}
</style>
